const STORAGE_KEY = 'chunkReloadTimestamp'
export const RELOAD_GUARD_MS = 10 * 60 * 1000

export function isChunkLoadError(err) {
  if (!err) return false
  const msg = err.message || String(err)
  return /Loading chunk \S+ failed|Loading CSS chunk \S+ failed|error loading dynamically imported module|Failed to fetch dynamically imported module|Importing a module script failed|Unable to preload CSS for |Couldn't resolve component "\S+" at /i.test(
    msg,
  )
}

export function shouldReload(storage = window.sessionStorage, now = Date.now()) {
  const last = Number(storage.getItem(STORAGE_KEY) || 0)
  return !last || now - last >= RELOAD_GUARD_MS
}

export function markReload(storage = window.sessionStorage, now = Date.now()) {
  storage.setItem(STORAGE_KEY, String(now))
}

export function installChunkReloader({
  router,
  reload = () => window.location.reload(),
  storage = window.sessionStorage,
  now = () => Date.now(),
} = {}) {
  const trigger = () => {
    if (!shouldReload(storage, now())) {
      console.warn('[chunkReloader] reload guard active, skipping reload')
      return false
    }
    markReload(storage, now())
    reload()
    return true
  }

  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault?.()
    trigger()
  })

  if (router && typeof router.onError === 'function') {
    router.onError((err) => {
      if (isChunkLoadError(err)) trigger()
    })
  }

  return trigger
}
